<template>
  <div>
    <div class="d-flex toolbar__appbox">
      <div
        :key="index"
        v-for="(service, index) in servicesFiltered()"
        class="pill text-center px-2"
      >
        <v-btn
          :id="service.domElementId"
          @click="pushPath(service)"
          icon
          width="64"
          height="64"
          color="transparent"
        >
          <SvgPill :iconType="getAppPill(service)" />
        </v-btn>
        <div class="pill--name secondary--text mt-2">
          {{
            $t(`portal.general.app_list.labels.apps.${getServiceName(service)}`)
          }}
        </div>
      </div>
      <div class="pill text-center px-2">
        <v-btn
          id="idBentoMenuMantenimiento"
          :disabled="loading"
          :loading="loading"
          icon
          width="64"
          height="64"
          color="transparent"
          @click="connectToMaintenanceService()"
        >
          <SvgPill iconType="pill_maintenance" />
        </v-btn>
        <div class="pill--name secondary--text mt-2">
          {{ $t('portal.general.app_list.labels.apps.maintenance') }}
        </div>
      </div>

      <v-divider v-if="!isPortal" class="mx-4 my-0" inset vertical></v-divider>
      <div v-if="!isPortal" class="pill grow text-center px-2">
        <v-btn
          id="idBentoMenuInicio"
          icon
          href="/portal"
          width="64"
          height="64"
          class="white"
          color="transparent"
        >
          <SvgPill iconType="pill_back_to_home" />
        </v-btn>
        <div class="pill--name secondary--text mt-2">
          {{ $t('general.apps.back_to_launcher') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAppNames } from 'single-spa'
import { SvgPill } from '@leapsight/styleguide'
import { mapGetters } from 'vuex'
import i18n from '@/plugins/i18n'
import { MaintenanceHelpers } from '@/helpers/mainExports'
export default {
  name: 'ToolBarAppBox',
  props: {
    services: {
      type: Array,
      required: true
    }
  },
  components: {
    SvgPill
  },
  data() {
    return {
      isPortal: false,
      appNames: getAppNames(),
      appMounted: '',
      loading: false
    }
  },
  methods: {
    pushPath(service) {
      window.location.href = `${window.location.origin}/${service.name}`
    },
    getAppPill(service) {
      let serviceName
      switch (service.name) {
        case 'live-tracking':
          serviceName = 'pill_live_track'
          break
        case 'fleet-management':
          serviceName = 'pill_fleet_mgnt'
          break
        case 'reports':
          serviceName = 'pill_reports'
          break
        default:
          break
      }
      return serviceName
    },
    getServiceName(service) {
      let serviceName
      switch (service.name) {
        case 'fleet-management':
          serviceName = 'fleet_management'
          break
        case 'live-tracking':
          serviceName = 'live_tracking'
          break
        case 'reports':
          serviceName = 'reports'
          break
        default:
          break
      }
      return serviceName
    },
    servicesFiltered() {
      const data = this.services.filter(item => {
        if (item.name !== this.appMounted) return item
      })
      return data
    },
    async connectToMaintenanceService() {
      this.loading = true
      const response = await MaintenanceHelpers.connectToMaintenanceService(
        this.connection
      )
      if (response.error) {
        const snackbar = {
          show: true,
          color: 'error',
          text: i18n.t(
            'portal.login.login.errors.maintenance_service_unreachable'
          )
        }
        this.$store.commit('ui/setSnackbar', snackbar)
      } else {
        window.open(response, '_newtab')
      }
      this.loading = false
    }
  },
  mounted() {
    this.appMounted = this.$route.path.split('/')[1]
    if (this.appMounted == 'portal') this.isPortal = true
  },
  computed: {
    ...mapGetters('auth', ['connection'])
  }
}
</script>

<style>
.toolbar__appbox:after,
.toolbar__appbox:before {
  bottom: 100%;
  right: 16px;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.toolbar__appbox:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #ffffff;
  border-width: 14px;
  margin-left: -30px;
}
.toolbar__appbox:before {
  border-color: rgba(213, 213, 213, 0);
  border-bottom-color: #d5d5d5;
  border-width: 15px;
  margin-left: -31px;
}
.toolbar__appbox svg {
  width: 64px;
  height: 64px;
}

.toolbar__appbox .pill .pill--name {
  font-size: 0.7rem;
}
.pill .svg-pill {
  width: initial !important;
}
</style>
